// @flow
import { _get } from "./methods";

export default {
  dashboard: (params: any) => _get("/admin/live_intent_flow/dashboard", params)
};
